import * as React from 'react';
import { Link } from 'react-router-dom';
import './irtech.css';

const IrtechPage = () => {
  return (
    <div className="irtech-page">
      <div className="irtech-page__container">
        <Link 
          to="/diagnostics/prerun-test-irtech" 
          className="irtech-page__button irtech-page__button--green"
        >
          Психофизическая диагностика
        </Link>
        <Link 
          to="/irtech-monitoring/monitorings" 
          className="irtech-page__button irtech-page__button--purple"
        >
          Педагогическая диагностика/Мониторинг
        </Link>
      </div>
    </div>
  );
};

export default IrtechPage;
